export const addVisitorValidation = {
  gate: [{ required: true, message: 'Gate is required!' }],
  type: [{ required: true, message: 'Type is required!' }],
  firstName: [{ required: true, message: 'First name is required!' }],
  lastName: [{ required: true, message: 'Last name is required!' }],
  companyName: [{ required: true, message: 'Company name is required!' }],
  carLicensePlate: [{ required: true, message: 'License is required!' }],
  carState: [{ required: true, message: 'License state is required!' }],
};
